const React = require('react');
const PropTypes = require('prop-types');
const DonutChart = require('components/charts/DonutChart/DonutChart');
const assetAllocationType = require('utilities/assetAllocationType');
const { formatValue } = require('../utilities/valueFormater');

const AssetAllocationsChart = ({ activeIndex, colors, data }) => (
    <DonutChart
        activeIndex={activeIndex}
        colors={colors}
        data={data}
        dataKey="sum"
        height={400}
        titles={{
            type: t => assetAllocationType(t),
            net: v => `${formatValue(v)}%`,
        }}
        width={'100%'}
    />
);

AssetAllocationsChart.defaultProps = {
    activeIndex: 0,
};

AssetAllocationsChart.propTypes = {
    activeIndex: PropTypes.number,
    colors: PropTypes.array.isRequired,
    data: PropTypes.array.isRequired,
};

module.exports = AssetAllocationsChart;
